import { DataManager as DataManagerPwa } from "../../../../../eventfive.awi.mosaic-pwa/theme/ts/awi/model/DataManager.js";
import { IData, VOListItem, VOGalleryList, VOGalleryMedia, VOHomeCategory, VOListItemLang, VOMediaContentLang, VOMediaContent, VOCategory, VOCategoryLang, VOConfig } from "./DataStructure.js";
import { VOBlog, VOBlogKind, VOMedia } from "../../../../../eventfive.awi.mosaic-pwa/theme/ts/awi/model/DataStructure.js";
import { DateUtil } from "../../../../../eventfive.awi.mosaic-pwa/theme/ts/awi/utils/DateUtil.js";
import { Resource } from "./Resource.js";
import { Language } from "../../../../../eventfive.awi.mosaic-pwa/theme/ts/awi/model/Language.js";
import { AppStorage } from "../../../../../eventfive.awi.mosaic-pwa/theme/ts/awi/model/AppStorage.js";

export class DataManager {
    public onComplete = e5.Signal.create();
    public onProgress = e5.Signal.create<[number]>();

    public data: IData = null;

    public pwa: DataManagerPwa;

    public config: VOConfig = null;

    private _url: string = "";
    // private _screenWidth: number = 1920;

    constructor() {
        this.pwa = new DataManagerPwa();
        this.pwa.warnSensorEntryNotFound = false;
        this.pwa.filterBlogs = false;
    }

    public load(url: string): void {
        var xhr = new XMLHttpRequest();
        this._url = url;
        $.ajax({
            xhr: () => {

                xhr.addEventListener("progress", (evt) => {

                    var loaded = evt.loaded;
                    var total = evt.total;

                    if (!evt.lengthComputable) {
                        total = parseInt(xhr.getResponseHeader("x-decompressed-content-length"));
                    }

                    if (total === 0 || isNaN(total))
                        return;

                    this.onProgress.dispatch(loaded / total);
                    // console.log(loaded, "of", total, Math.floor((loaded / total) * 100) + "%");
                }, false);
                return xhr;
            },
            cache: false,
            type: 'GET',
            url: url,
            error: (xhr) => {

                // if (AppStorage.getItem("data")) {
                //     this.data = JSON.parse(AppStorage.getItem("data"));
                //     this.finalize();
                //     this.onComplete.dispatch();
                // }
                // else {
                var msg = "The data could not be loaded";
                e5.Toast.showText(msg, 30);
                // }
            },
            success: (data) => {
                // if (AppStorage) {
                //     AppStorage.setItem("data", xhr.responseText);
                // }

                this.data = data;
                this.finalize();
                this.onComplete.dispatch();
            }
        });
    }

    private retry(): void {
        this.load(this._url);
    }

    private finalize(): void {
        this.pwa.fromData(this.data.pwa);

        /**
         * Get global config.
         */
        this.config = e5.array.match(this.data.config, "title", e5.Url.params.get("config", "Default"));
        if (!this.config) {
            e5.array.match(this.data.config, "title", "Default");
            if (!this.config) {
                this.config = {
                    title: "Fallback",
                    initial_category: null,
                    initial_logbook_diagram: "temperature",
                    idle_mode: "panorama",
                    idle_mode_timeout: 120,
                    idle_mode_category: null,
                    initial_logbook_view: "map",
                    idle_mode_video_en: null,
                    idle_mode_video_de: null
                };
            }
        }
        this.config.initial_category = this.data.category.id(this.config.initial_category as any);
        this.config.idle_mode_category = this.data.category.id(this.config.idle_mode_category as any);

        var homeCategoryId: number = 1;
        for (var home of this.data.home) {
            if (!home.categories)
                home.categories = [];
            for (var homeCategory of home.categories) {
                homeCategory.id = homeCategoryId++;
                homeCategory.home_category = this.data.category.id(homeCategory.home_category as any);
                // homeCategory.targetX = Math.round(-homeCategory.home_category_x + this._screenWidth * 0.5);
            }

            home.about_awi = this.data.category.id(home.about_awi as any);
            home.about_mosaic = this.data.category.id(home.about_mosaic as any);

            if (!home.menus)
                home.menus = [];
            for (var menuCategory of home.menus) {
                menuCategory.home_menu = this.data.category.id(menuCategory.home_menu as any);
            }

            if (!home.elements)
                home.elements = [];
            var index = 0;
            for (var element of home.elements) {
                element.index = index++;
                // if (!element.category) {
                //     var nearest: VOHomeCategory = null;
                //     var dist = Number.MAX_VALUE;
                //     for (var homeCategory of home.categories) {
                //         var d = Math.abs(homeCategory.home_category_x - element.x);
                //         if (d < dist) {
                //             dist = d;
                //             nearest = homeCategory;
                //         }
                //     }
                //     element.category = nearest ? nearest.home_category : null;
                // }
                // else {
                //     element.category = this.data.category.id(element.category as any);
                // }
                // if (!element.category) {
                //     console.warn("Could not find related category for element. Try to fallback to first map/home-category.");
                //     element.category = home.categories[0] ? home.categories[0].home_category : null;
                // }
                // element.category = this.data.category.id(element.category as any);
            }
            home.categories.sort((a, b) => a.home_category_x - b.home_category_x);
        }

        var mediaId = 10000;
        for (var category of this.data.category) {
            if (!category.kind) {
                category.kind = "gallery";
            }

            category.image = Language.current == "de" ? (category.image_de || category.image) : (category.image || category.image_de);

            if (!category.galleries) {
                category.galleries = {
                    all: [],
                    media: []
                };
            } else {
                category.galleries = this.removeWrongLanguageMediaFromGalleryList(category.galleries as any) as any;
                category.galleries = {
                    all: category.galleries as any,
                    media: this.prepareGalleryList(category.galleries as any)
                };

                for (var g of category.galleries.all) {
                    for (var m of g.list_item_medias) {
                        m.mediaId = mediaId++;
                    }
                }
            }

            this.translateCategory(category);
        }

        var blogs = this.pwa.data.blog.slice();
        blogs.sort((a, b) => a.date.getTime() - b.date.getTime());
        this.data.blogs_mosaic = this.getGalleryFromBlogs(blogs, "mosaic");
        this.data.blogs_mosaic_grouped = this.getGalleryFromBlogs(blogs, "mosaic", true);
        this.data.blogs_nansen = this.getGalleryFromBlogs(blogs, "nansen");
        this.data.blogs_nansen_grouped = this.getGalleryFromBlogs(blogs, "nansen", true);
    }

    private createMedia(url: string, w: number, h: number): VOMedia {
        return {
            title_de: "",
            title_en: "",
            description_de: "",
            description_en: "",
            author_de: "",
            author_en: "",
            height: 474,
            width: 512,
            type: "image",
            url: url,
            sizes: {
                "large-width": w,
                "large-height": h,
                "medium-width": w,
                "medium-height": h,
                "thumbnail-width": w,
                "thumbnail-height": h,
                large: url,
                medium: url,
                thumbnail: url
            }
        };
    }

    private getGalleryFromBlogs(blogs: VOBlog[], kind: VOBlogKind, groupByMonth: boolean = false): VOGalleryList {
        var list: VOListItem[] = [];

        var gallery: VOListItem = null;
        var textGallery: VOListItem = null;

        var fallbackMedia: VOMedia = null;
        if (kind === "nansen") {
            fallbackMedia = this.createMedia(Resource.asset("pwa-fallback-image-nansen.jpg"), 512, 474);
        } else {
            fallbackMedia = this.createMedia(Resource.asset("pwa-fallback-image-mosaic.jpg"), 512, 474);
        }

        var last: VOBlog = null;
        for (var blog of blogs) {
            if (blog.media_type === "youtube" || blog.kind !== kind)
                continue;

            var media = blog.image ? blog.image : (Language.current === "en" ? (blog.video_en || blog.video_de) : (blog.video_de || blog.video_en));
            if (!blog.hasMedia) {
                // media = fallbackMedia;
                media = null;
            }

            var fullDate = (blog.date.getUTCDate()) + ".";
            fullDate += " " + e5.Text.month(blog.date.getUTCMonth(), Language.current) + "";
            fullDate += " " + blog.date.getUTCFullYear() + "";

            var title = "";

            if (blog.title_en || blog.title_de) {
                title = Language.trans(blog.title_de, blog.title_en);
            }

            var subtitle = fullDate;

            // subtitle += "Day " + blog.day;
            // if (blog.day < 0) {
            //     if (blog.day === -1)
            //         subtitle = Math.abs(blog.day) + " day to departure";
            //     else
            //         subtitle = Math.abs(blog.day) + " days to departure";
            // }            

            var galleryMedia: VOGalleryMedia = {
                mediaId: blog.id,
                title: title,
                subtitle: subtitle,
                description: Language.trans(blog.text_de, blog.text_en),
                author: Language.trans(blog.captionDe, blog.captionEn).trim(),//.replace("©", "")
                height: media ? media.height : 0,
                width: media ? media.width : 0,
                sizes: media ? media.sizes : null,
                type: media ? media.type : "none",
                url: media ? media.url : "",
                date: blog.date,
                languages: "all"
            };

            var breadcrumbTitle = title;

            if (groupByMonth) {
                breadcrumbTitle = e5.Text.month(blog.date.getMonth(), Language.current) + " " + blog.date.getFullYear();
                //subtitle = "Day " + Math.max(this.pwa.dateToDay(firstDayOfMonth, blog.kind), 1) + " to " + Math.max(this.pwa.dateToDay(lastDayOfMonth, blog.kind), 1);
                galleryMedia.breadcrumbTitle = breadcrumbTitle;
            }

            if (!groupByMonth || !last || DateUtil.monthDiff(last.date, blog.date) > 0) {
                var firstDayOfMonth = new Date(blog.date);
                firstDayOfMonth.setUTCDate(1);
                var lastDayOfMonth = new Date(blog.date);
                lastDayOfMonth.setUTCMonth(lastDayOfMonth.getUTCMonth() + 1);
                lastDayOfMonth.setUTCDate(0);

                gallery = {
                    validCount: galleryMedia.url ? 1 : 0,
                    list_item_medias: galleryMedia.url ? [galleryMedia] : [],
                    list_item_kind: "gallery",
                    list_item_use_text_first_media: groupByMonth ? true : false,
                    list_item_title: title,
                    list_item_subtitle: subtitle,
                    list_item_description: galleryMedia.description,
                    blogId: blog.id,
                    date: blog.date,
                    breadcrumbTitle: breadcrumbTitle
                };
                list.push(gallery);
                // gallery.gallery_medias.push(galleryMedia);
            }
            else if (!galleryMedia.url) {
                //Do not add media into the gallery when no media is given
                // gallery.validCount++;
                // gallery.list_item_medias.push(galleryMedia);
            }
            else if (gallery) {
                gallery.validCount++;
                gallery.list_item_medias.push(galleryMedia);
            }

            last = blog;

        }

        for (var gallery of list) {
            if (gallery.validCount === 0) {
                gallery.list_item_kind = "text";
            }
        }

        return {
            all: list,
            media: this.prepareGalleryList(list)
        };
    }

    private translateListItem(item: VOListItem): void {
        var k = item as VOListItemLang;
        item.list_item_title = Language.trans(k.list_item_title_de, k.list_item_title);
        item.list_item_subtitle = Language.trans(k.list_item_subtitle_de, k.list_item_subtitle);
        item.list_item_description = Language.trans(k.list_item_description_de, k.list_item_description);
    }

    private translateListItemMedia(item: VOMediaContent): void {
        var k = item as VOMediaContentLang;
        item.title = Language.trans(k.title_de, k.title);
        item.subtitle = Language.trans(k.subtitle_de, k.subtitle);
        item.description = Language.trans(k.description_de, k.description);
        item.author = Language.trans(k.author_de, k.author);
    }

    private translateCategory(item: VOCategory): void {
        var k = item as VOCategoryLang;
        item.title = Language.trans(k.title_de, k.title);
        item.subtitle = Language.trans(k.subtitle_de, k.subtitle);
        item.description = Language.trans(k.description_de, k.description);

        if (item.kind == "pdf") {
            if (Language.current == "de") {
                item.pdfs = item.pdfs_de;
            }
        }
    }

    private removeWrongLanguageMediaFromGalleryList(list: VOListItem[]): VOListItem[] {
        var filtered: VOListItem[] = [];

        for (var gallery of list) {
            if (gallery.list_item_kind !== "text" && gallery.list_item_medias && gallery.list_item_medias.length > 0) {
                for (var i = 0; i < gallery.list_item_medias.length; ++i) {
                    var m = gallery.list_item_medias[i];
                    if (m.languages == "de" && Language.current == "en"
                        || m.languages == "en" && Language.current == "de") {
                        gallery.list_item_medias.splice(i, 1);
                        i--;
                    } else {
                        this.translateListItemMedia(m);
                    }
                }

                if (gallery.list_item_medias.length > 0) {
                    filtered.push(gallery);
                }
            } else {
                filtered.push(gallery);
            }
        }
        return filtered;
    }

    private prepareGalleryList(list: VOListItem[]): VOListItem[] {

        var filtered: VOListItem[] = [];
        for (var gallery of list) {
            gallery.validCount = 0;
            this.translateListItem(gallery);
            if (gallery.list_item_kind !== "text" && gallery.list_item_medias && gallery.list_item_medias.length > 0) {


                for (var i = 0; i < gallery.list_item_medias.length; ++i) {
                    var m = gallery.list_item_medias[i];
                    if (m.languages == "de" && Language.current == "en"
                        || m.languages == "en" && Language.current == "de") {
                        gallery.list_item_medias.splice(i, 1);
                        i--;
                    } else {
                        this.translateListItemMedia(m);
                    }
                }

                if (gallery.list_item_medias.length > 0) {
                    filtered.push(gallery);
                }
            }
        }
        list = filtered;

        for (var galleryIndex = 0; galleryIndex < list.length; ++galleryIndex) {
            var gallery = list[galleryIndex];
            gallery.index = galleryIndex;
            gallery.prev = list[e5.Calc.wrap(galleryIndex - 1, list.length)];
            gallery.next = list[e5.Calc.wrap(galleryIndex + 1, list.length)];
        }

        for (var galleryIndex = 0; galleryIndex < list.length; ++galleryIndex) {
            var gallery = list[galleryIndex];

            gallery.validCount = 0;

            if (gallery.list_item_use_text_first_media) {
                gallery.list_item_title = "";
                gallery.list_item_subtitle = "";
                gallery.list_item_description = "";
            }

            for (var mediaIndex = 0; mediaIndex < gallery.list_item_medias.length; ++mediaIndex) {
                var media = gallery.list_item_medias[mediaIndex];
                media.gallery = gallery;
                media.index = mediaIndex;

                if (media.url)
                    gallery.validCount++;

                if (media.index === 0) {
                    var prev = gallery.prev;
                    while (prev != gallery && !media.prev) {
                        media.prev = prev.list_item_medias[prev.list_item_medias.length - 1];
                        prev = prev.prev;
                    }

                    if (!media.prev)
                        media.prev = gallery.list_item_medias[e5.Calc.wrap(mediaIndex - 1, gallery.list_item_medias.length)];
                }

                if (media.index === gallery.list_item_medias.length - 1) {
                    var next = gallery.next;
                    while (next != gallery && !media.next) {
                        media.next = next.list_item_medias[0];
                        next = next.next;
                    }
                    if (!media.next)
                        media.next = gallery.list_item_medias[e5.Calc.wrap(mediaIndex + 1, gallery.list_item_medias.length)];
                }

                if (!media.prev) {
                    media.prev = gallery.list_item_medias[mediaIndex - 1];
                }

                if (!media.next) {
                    media.next = gallery.list_item_medias[mediaIndex + 1];
                }

                if (!media.next) {
                    media.next = media;
                }
                if (!media.prev) {
                    media.prev = media;
                }

                var fallbackToGalleryText = true;

                if (fallbackToGalleryText && !media.title && !media.subtitle && !media.description) {
                    media.title = gallery.list_item_title;
                    media.subtitle = gallery.list_item_subtitle;
                    media.description = gallery.list_item_description;
                }
            }
        }

        for (var galleryIndex = 0; galleryIndex < list.length; ++galleryIndex) {
            var gallery = list[galleryIndex];

            for (var mediaIndex = 0; mediaIndex < gallery.list_item_medias.length; ++mediaIndex) {
                var media = gallery.list_item_medias[mediaIndex];

                var prevValid = media.prev;
                while (prevValid != media) {
                    if (prevValid.type !== "none") {
                        break;
                    }
                    prevValid = prevValid.prev;
                }
                media.prevValid = prevValid;

                var nextValid = media.next;
                while (nextValid != media) {
                    if (nextValid.type !== "none") {
                        break;
                    }
                    nextValid = nextValid.next;
                }
                media.nextValid = nextValid;
            }
        }

        return list;
    }
}